import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { GeraetDto } from "../../api/models";

export const GeraeteActions = createActionGroup({
    source: 'Geraete',
    events: {
        "Load Geraete": emptyProps(),
        "Load Geraete Success": props<{geraete: GeraetDto[]}>(),
        "Load Geraete Failure": props<{error: unknown}>(),
    },
})
